import React from 'react'
import { ChevronDownIcon } from '@heroicons/react/24/outline'
import { useMediaQuery } from '@mantine/hooks'
import dayjs from 'dayjs'
import {
  projectSlideList,
  projectOutputList,
  curriculumDetailList,
  classOneSlideList,
  classTwoSlideList,
  classThreeDetailList,
  classSupportList,
  careerSupportList,
  benefitSlideList,
  reviewList,
  ApplySchedule1List,
  ApplySchedule2List,
  EduScheduleList,
  bootCampFaqList,
  bootCampFaqTabList,
} from '../../../../constants/kdt-design-5th'
import Link from 'next/link'
import Image from 'next/image'
import ReactPlayer from 'react-player'
import { useMemo, useState } from 'react'
import { useCopyUrlShare } from 'shared/hooks/useCopyUrlShare'
import InternshipAccordion from './InternshipAccordion'
import InternshipTab from './InternshipTab'
import CurriculumAccordion from './CurriculumAccordion'
import CurriculumTab from './CurriculumTab'
import {
  ProjectSliderItem,
  ProjectOutputSliderItem,
  ClassOneSliderItem,
  ClassTwoSliderItem,
  ClassSupportSliderItem,
  BenefitSliderItem,
  ReviewSliderItem,
} from './SliderItem'
import styles from './kdt-design-5th.module.scss'
import { schoolNavList, ScrollNav } from './ScrollNav'

const DesignSchool5th = () => {
  const isMobile = useMediaQuery('(max-width: 1023px)')
  const [faqTab, setFaqTab] = useState('apply')
  const allFaqs = [
    ...bootCampFaqList.apply,
    ...bootCampFaqList.nebeka,
    ...bootCampFaqList.employment,
    ...bootCampFaqList.edu,
    ...bootCampFaqList.benefit,
    ...bootCampFaqList.etc,
  ]
  const faqList = faqTab === 'all' ? allFaqs : bootCampFaqList[faqTab]
  const onClickFaqTab = (value: string) => {
    setFaqTab(value)
  }
  const earlySessionDate = new Date('2025-03-12 19:00')
  const isAfterEarlySessionDate = useMemo(() => dayjs().isAfter(earlySessionDate), [])
  const { copyUrlShare } = useCopyUrlShare()

  return (
    <div>
      {/* Section1_키비주얼 */}
      <section className="bg-[#FFE0C7]">
        <div className={`${styles.section1_kv} relative w-full`}>
          <div className="absolute left-0 top-0 w-full">
            <Image
              src={`https://d35ai18pny966l.cloudfront.net/course/kdt/kdt-design-5th/section1_kv_after_${
                isMobile ? 'm' : 'pc'
              }.png`}
              layout="fill"
              objectFit="cover"
              className="!relative z-10 w-full object-cover"
              alt="[멋쟁이사자처럼] 정규직 전환부터 개발자 협업까지, 3번의 인턴십 기회! - 역대급 인턴십 기회 - UXUI 부트캠프"
            />
          </div>
        </div>
      </section>

      {/* Section2_핵심포인트 */}
      <section className="bg-[#FFF3EB] py-6 lg:py-20">
        <div className="mx-auto w-full max-w-7xl px-4 lg:px-6">
          <ul className="flex w-full flex-col gap-3 lg:flex-row lg:gap-4">
            <li
              data-aos-once="true"
              data-aos="fade-up"
              data-aos-easing="ease"
              data-aos-duration="800"
              data-aos-delay="600"
              className="flex flex-1 flex-row items-center justify-center gap-3 border border-black bg-white px-4 py-3 lg:gap-4 lg:px-6 lg:py-5"
            >
              <div className="flex flex-1 flex-col items-start justify-center">
                <p className="mb-1 inline-block bg-[rgba(255,119,16,0.10)] px-2 py-1 text-[10px] font-semibold text-yellow-450 lg:mb-2 lg:px-3 lg:text-xs lg:font-bold">
                  POINT 1
                </p>
                <p className="text-sm font-semibold leading-normal text-label-normal lg:text-lg lg:font-bold">
                  기업 실무를 경험하는
                  <br />총 3번의 인턴십 기회
                </p>
              </div>
              <img
                className="h-[73px] w-[73px] object-cover lg:h-[90px] lg:w-[90px]"
                src="https://d35ai18pny966l.cloudfront.net/course/kdt/kdt-design-5th/section2_icon1.png"
                alt="-"
              />
            </li>
            <li
              data-aos-once="true"
              data-aos="fade-up"
              data-aos-easing="ease"
              data-aos-duration="800"
              data-aos-delay="600"
              className="flex flex-1 flex-row items-center justify-center gap-3 border border-black bg-white px-4 py-3 lg:gap-4 lg:px-6 lg:py-5"
            >
              <div className="flex flex-1 flex-col items-start justify-center">
                <p className="mb-1 inline-block bg-[rgba(255,119,16,0.10)] px-2 py-1 text-[10px] font-semibold text-yellow-450 lg:mb-2 lg:px-3 lg:text-xs lg:font-bold">
                  POINT 2
                </p>
                <p className="text-sm font-semibold leading-normal text-label-normal lg:text-lg lg:font-bold">
                  데이터 기반으로 문제 해결 능력을
                  <br />
                  기를 수 있는 커리큘럼
                </p>
              </div>
              <img
                className="h-[73px] w-[73px] object-cover lg:h-[90px] lg:w-[90px]"
                src="https://d35ai18pny966l.cloudfront.net/course/kdt/kdt-design-5th/section2_icon2.png"
                alt="-"
              />
            </li>
            <li
              data-aos-once="true"
              data-aos="fade-up"
              data-aos-easing="ease"
              data-aos-duration="800"
              data-aos-delay="600"
              className="flex flex-1 flex-row items-center justify-center gap-3 border border-black bg-white px-4 py-3 lg:gap-4 lg:px-6 lg:py-5"
            >
              <div className="flex flex-1 flex-col items-start justify-center">
                <p className="mb-1 inline-block bg-[rgba(255,119,16,0.10)] px-2 py-1 text-[10px] font-semibold text-yellow-450 lg:mb-2 lg:px-3 lg:text-xs lg:font-bold">
                  POINT 3
                </p>
                <p className="text-sm font-semibold leading-normal text-label-normal lg:text-lg lg:font-bold">
                  기획부터 개선까지
                  <br />
                  3단계 실전 프로젝트
                </p>
              </div>
              <img
                className="h-[73px] w-[73px] object-cover lg:h-[90px] lg:w-[90px]"
                src="https://d35ai18pny966l.cloudfront.net/course/kdt/kdt-design-5th/section2_icon3.png"
                alt="-"
              />
            </li>
          </ul>

          <hr
            data-aos-once="true"
            data-aos="fade-up"
            data-aos-easing="ease"
            data-aos-duration="800"
            data-aos-delay="600"
            className="my-6 border-label-normal lg:my-8"
          />

          <ul
            data-aos-once="true"
            data-aos="fade-up"
            data-aos-easing="ease"
            data-aos-duration="800"
            data-aos-delay="600"
            className="mt-6 flex w-full flex-col lg:mt-0"
          >
            <li className="flex w-full flex-row items-start border-b border-label-normal pb-3 lg:items-center lg:pb-4">
              <h6 className="flex w-[126px] flex-row items-center justify-start gap-3 text-sm font-semibold text-label-normal lg:w-[calc(33.33%+16px)] lg:gap-4 lg:text-base">
                <img
                  className="h-5 w-5 lg:h-6 lg:w-6"
                  src="https://d35ai18pny966l.cloudfront.net/course/kdt/kdt-design-5th/section2_icon4.png"
                  alt="-"
                />
                지원기간
              </h6>
              <p className="text-sm text-label-normal lg:w-2/3 lg:text-base">
                25.02.24(월) 오후 2시 ~ <br className="block lg:hidden" />
                25.03.29(토) 오후 11시
              </p>
            </li>
            <li className="flex w-full flex-row items-start pt-3 lg:pt-4">
              <h6 className="flex w-[126px] flex-row items-center justify-start gap-3 text-sm font-semibold text-label-normal lg:w-[calc(33.33%+16px)] lg:gap-4 lg:text-base">
                <img
                  className="h-5 w-5 lg:h-6 lg:w-6"
                  src={
                    'https://d35ai18pny966l.cloudfront.net/course/kdt/kdt-design-5th/section2_icon5.png'
                  }
                  alt="-"
                />
                수강기간
              </h6>
              <p className="text-sm text-label-normal lg:w-2/3 lg:text-base">
                25.03.31(월) ~ 25.08.22(금) <br className="block lg:hidden" />
                평일 오전 9시 ~ 오후 6시 (일 8시간 교육)
              </p>
            </li>
          </ul>

          <ul
            data-aos-once="true"
            data-aos="fade-up"
            data-aos-easing="ease"
            data-aos-duration="800"
            data-aos-delay="600"
            className="mt-6 flex w-full flex-col gap-3 lg:mt-8 lg:flex-row lg:gap-4"
          >
            <li className="flex w-full flex-row items-center justify-center border border-[rgba(0,224,255,0.3)] bg-white py-4 lg:w-auto lg:flex-1 lg:justify-start lg:px-6 lg:py-5">
              <p className="text-sm font-bold text-label-normal lg:text-lg">
                내일배움카드로 교육비 무료
              </p>
            </li>
            <li className="flex w-full flex-row items-center justify-center border border-[rgba(0,224,255,0.3)] bg-white py-4 lg:w-auto lg:flex-1 lg:justify-start lg:px-6 lg:py-5">
              <p className="text-sm font-bold text-label-normal lg:text-lg">
                매월 최대 81만원 지원금 신청 가능
              </p>
            </li>
          </ul>
        </div>
      </section>

      <ScrollNav schoolNavList={schoolNavList} />

      {/* Section3_시장성 */}
      <section
        className={`${styles.section3_bg} min-h-[1012px] bg-[#FCFAF9] pt-20 lg:min-h-[1370px] lg:pt-36`}
      >
        <div className="mx-auto w-full max-w-7xl px-4 lg:px-6">
          <div
            data-aos-once="true"
            data-aos="fade-up"
            data-aos-easing="ease"
            data-aos-duration="800"
            data-aos-delay="300"
            className="mb-[25px] flex flex-col items-center justify-center gap-3 lg:mb-[57px] lg:gap-7"
          >
            <h4 className="text-center text-2xl font-bold leading-snug text-label-normal lg:text-4xl lg:leading-[1.4]">
              UXUI 디자이너의 치열한 <br className="block lg:hidden" />
              취업 경쟁, <br className="hidden lg:block" />
              <span className="text-yellow-450">’인턴십’으로 완성된</span>
              <br />
              <span className="text-yellow-450">’실무 중심 포트폴리오’</span>가 핵심!
            </h4>
            <p className="text-center text-sm leading-normal text-label-normal lg:text-lg">
              일반적인 포트폴리오만으로는 부족한게 현실.
              <br />
              이제 실무 경험이 있는 UXUI 디자이너를 <br className="block lg:hidden" />
              원하는 기업이 늘어나고 있습니다.
            </p>
          </div>

          <div
            data-aos-once="true"
            data-aos="fade-up"
            data-aos-easing="ease"
            data-aos-duration="800"
            data-aos-delay="600"
            className={`${styles.section3_imgbox} mb-[88px] w-full lg:mb-40`}
          >
            <Image
              src={`https://d35ai18pny966l.cloudfront.net/course/kdt/kdt-design-5th/section3_img_ver3_${
                isMobile ? 'm' : 'pc'
              }.png`}
              layout="fill"
              objectFit="contain"
              className="!relative w-full"
              alt="-"
            />
          </div>

          <p
            data-aos-once="true"
            data-aos="fade-up"
            data-aos-easing="ease"
            data-aos-duration="800"
            data-aos-delay="600"
            className="text-center text-xl font-bold leading-tight text-label-normal lg:text-[32px] lg:leading-snug"
          >
            그렇다면, 신입 UXUI 디자이너는
            <br />
            어떻게 실무 경험을 쌓을까요?
          </p>

          <div
            className={`${styles.section3_icon_arrow} absolute left-1/2 w-[71.47px] -translate-x-1/2 lg:w-[120px]`}
          >
            <img
              className="w-full object-contain"
              src="https://d35ai18pny966l.cloudfront.net/course/kdt/kdt-design-5th/section3_icon_arrow.png"
              alt="-"
            />
          </div>
        </div>
      </section>

      {/* Section4_인턴십 */}
      <section
        className={`${styles.section4_bg} min-h-[789px] bg-[#FCFAF9] pb-[90px] pt-4 lg:min-h-[1515px] lg:pb-[180px] lg:pt-10`}
      >
        <div className="mx-auto w-full max-w-7xl px-4 lg:px-6">
          <div
            data-aos-once="true"
            data-aos="fade-up"
            data-aos-easing="ease"
            data-aos-duration="800"
            data-aos-delay="300"
            className="mb-12 flex flex-col items-center justify-center lg:mb-16"
          >
            <p className="mb-2 text-sm font-bold text-yellow-450 lg:mb-4 lg:text-lg">인턴십</p>
            <h4 className="text-center text-2xl font-bold leading-snug text-label-normal lg:text-4xl lg:leading-[1.4]">
              3번의 인턴십 기회!
              <br />
              실제 기업에서의 실무 경험으로
              <br />
              취업 경쟁력을 높이세요
            </h4>
            <div className="my-[18px] w-full lg:mx-auto lg:my-7 lg:max-w-[621px]">
              <Image
                src={`https://d35ai18pny966l.cloudfront.net/course/kdt/kdt-design-5th/section4_intro_ver3_${
                  isMobile ? 'm' : 'pc'
                }.png`}
                layout="fill"
                objectFit="cover"
                className="!relative"
                alt="-"
              />
            </div>
            <p className="text-center text-sm leading-normal text-label-normal lg:text-lg">
              정규직 전환형 인턴십부터 개발자 협업 프로젝트까지,
              <br />
              기업이 원하는 실무 경험을 직접 쌓을 수 있습니다.
            </p>
          </div>

          <div
            data-aos-once="true"
            data-aos="fade-up"
            data-aos-easing="ease"
            data-aos-duration="800"
            data-aos-delay="600"
            className={`${styles.curriculum_accordion_wrap} ${styles.curriculum_accordion_wrap_section4} hidden flex-row overflow-hidden border border-black bg-white lg:flex`}
          >
            <InternshipTab />
          </div>
        </div>

        <ul
          data-aos-once="true"
          data-aos="fade-up"
          data-aos-easing="ease"
          data-aos-duration="800"
          data-aos-delay="600"
          className={`${styles.curriculum_accordion_wrap} flex flex-col overflow-hidden lg:hidden`}
        >
          <InternshipAccordion />
        </ul>

        <p
          data-aos-once="true"
          data-aos="fade-up"
          data-aos-easing="ease"
          data-aos-duration="800"
          data-aos-delay="600"
          className="mx-auto mt-12 px-4 text-center text-xs font-medium leading-normal text-label-neutral lg:mt-16 lg:px-6 lg:text-base lg:font-normal"
        >
          *교육생 훈련 상황 및 회사 사정에 따라 지원 내용이 <br className="block lg:hidden" />
          변동될 수 있습니다.
        </p>
      </section>

      {/* Section5_커리큘럼 */}
      <section
        id="curriculum"
        className="min-h-[1044px] bg-[#FCFAF9] pb-24 pt-20 lg:min-h-[1761px] lg:pb-[180px] lg:pt-[156px]"
      >
        <div className="mx-auto w-full max-w-7xl px-4 lg:px-6">
          <div
            data-aos-once="true"
            data-aos="fade-up"
            data-aos-easing="ease"
            data-aos-duration="800"
            data-aos-delay="300"
            className="mb-12 flex flex-col items-center justify-center lg:mb-16"
          >
            <p className="mb-2 text-sm font-bold text-yellow-450 lg:mb-4 lg:text-lg">커리큘럼</p>
            <h4 className="mb-3 text-center text-2xl font-bold leading-snug text-label-normal lg:mb-7 lg:text-4xl lg:leading-[1.4]">
              좋은 디자인만으로는 부족합니다.
              <br />
              정성적+정량적 데이터 기반으로 <br className="block lg:hidden" />
              <span className="text-yellow-450">‘진짜 문제 해결 능력’</span> 을 길러요
            </h4>
            <p className="text-center text-sm leading-normal text-label-normal lg:text-lg">
              기업에서는 ‘데이터 기반 사고력’을 선호합니다.
              <br />
              현업 전문가들과 함께 만든 커리큘럼을 통해, <br className="block lg:hidden" />
              이론부터 실무까지 탄탄하게 쌓아보세요!
            </p>
          </div>

          <ul
            className={`${styles.section5_intro_list} mb-12 flex flex-col gap-3 lg:mb-16 lg:flex-row lg:gap-4`}
          >
            <li
              data-aos-once="true"
              data-aos="fade-up"
              data-aos-easing="ease"
              data-aos-duration="800"
              data-aos-delay="600"
              className="flex h-[70px] w-full flex-row items-center border border-black bg-white lg:h-[130px] lg:w-auto lg:flex-1"
            >
              <img
                className="h-full w-[70px] object-contain lg:w-auto"
                src="https://d35ai18pny966l.cloudfront.net/course/kdt/kdt-design-5th/section5_icon1.png"
                alt="-"
              />
              <div className="flex h-full flex-1 items-center border-l border-black px-4 lg:px-[23px]">
                <p className="text-sm font-bold leading-normal text-label-normal lg:text-lg">
                  사용자를 이해하고,
                  <br />
                  최적의 UX를 <br className="hidden lg:block" />
                  설계하는 역량
                </p>
              </div>
            </li>
            <li
              data-aos-once="true"
              data-aos="fade-up"
              data-aos-easing="ease"
              data-aos-duration="800"
              data-aos-delay="800"
              className="flex h-[70px] w-full flex-row items-center border border-black bg-white lg:h-[130px] lg:w-auto lg:flex-1"
            >
              <img
                className="h-full w-[70px] object-contain lg:w-auto"
                src="https://d35ai18pny966l.cloudfront.net/course/kdt/kdt-design-5th/section5_icon2.png"
                alt="-"
              />
              <div className="flex h-full flex-1 items-center border-l border-black px-4 lg:px-[23px]">
                <p className="text-sm font-bold leading-normal text-label-normal lg:text-lg">
                  데이터 기반 <br className="hidden lg:block" />
                  문제를 정의하고
                  <br />
                  해결하는 능력
                </p>
              </div>
            </li>
            <li
              data-aos-once="true"
              data-aos="fade-up"
              data-aos-easing="ease"
              data-aos-duration="800"
              data-aos-delay="1000"
              className="flex h-[70px] w-full flex-row items-center border border-black bg-white lg:h-[130px] lg:w-auto lg:flex-1"
            >
              <img
                className="h-full w-[70px] object-contain lg:w-auto"
                src="https://d35ai18pny966l.cloudfront.net/course/kdt/kdt-design-5th/section5_icon3.png"
                alt="-"
              />
              <div className="flex h-full flex-1 items-center border-l border-black px-4 lg:px-[23px]">
                <p className="text-sm font-bold leading-normal text-label-normal lg:text-lg">
                  디자인 툴을 활용한 <br className="hidden lg:block" />
                  직관적이고
                  <br />
                  일관된 UI 설계 역량
                </p>
              </div>
            </li>
          </ul>

          <div
            data-aos-once="true"
            data-aos="fade-up"
            data-aos-easing="ease"
            data-aos-duration="800"
            data-aos-delay="600"
            className={`${styles.curriculum_accordion_wrap} hidden flex-row overflow-hidden border border-black bg-white lg:flex`}
          >
            <CurriculumTab curriculumDetailList={curriculumDetailList} />
          </div>
        </div>

        <ul
          data-aos-once="true"
          data-aos="fade-up"
          data-aos-easing="ease"
          data-aos-duration="800"
          data-aos-delay="600"
          className={`${styles.curriculum_accordion_wrap} flex flex-col overflow-hidden lg:hidden`}
        >
          {curriculumDetailList.map((curriculum, idx) => (
            <CurriculumAccordion contents={curriculum} key={curriculum.titleM} idx={idx} />
          ))}
        </ul>
      </section>

      {/* Section6_프로젝트 */}
      <section
        id="project"
        className="min-h-[1133px] bg-[#FFE7D5] pb-24 pt-20 lg:min-h-[1467px] lg:pb-[180px] lg:pt-[156px]"
      >
        <div className="mx-auto w-full max-w-7xl px-4 lg:px-6">
          <div
            data-aos-once="true"
            data-aos="fade-up"
            data-aos-easing="ease"
            data-aos-duration="800"
            data-aos-delay="300"
            className="mb-10 flex flex-col items-center justify-center lg:mb-16"
          >
            <p className="mb-2 text-sm font-bold text-yellow-450 lg:mb-4 lg:text-lg">프로젝트</p>
            <h4 className="text-center text-2xl font-bold leading-snug text-label-normal lg:text-4xl lg:leading-[1.4]">
              3단계 실전 프로젝트로
              <br />
              경쟁력 있는 포트폴리오를 완성해요
            </h4>
            <div className="my-[18px] w-full max-w-[309px] lg:mx-auto lg:my-7 lg:max-w-[605px]">
              <Image
                src={`https://d35ai18pny966l.cloudfront.net/course/kdt/kdt-design-5th/section6_intro_${
                  isMobile ? 'm' : 'pc'
                }.png`}
                layout="fill"
                objectFit="cover"
                className="!relative"
                alt="-"
              />
            </div>
            <p className="text-center text-sm leading-normal text-label-normal lg:text-lg">
              개인의 성장에 집중하는 프로젝트를 한 번,
              <br />
              협업 경험을 쌓을 수 있는 실전 프로젝트를 두 번 진행해요.
            </p>
          </div>

          <div
            data-aos-once="true"
            data-aos="fade-up"
            data-aos-easing="ease"
            data-aos-duration="800"
            data-aos-delay="600"
            className={`${styles.section6_slider}`}
          >
            <ProjectSliderItem contents={projectSlideList} />
          </div>
        </div>
      </section>

      {/* Section7_수료생 결과물 */}
      <section className="min-h-[569px] bg-trueGray-800 pb-24 pt-20 lg:min-h-[1066px] lg:pb-[180px] lg:pt-[156px]">
        <div className="mx-auto w-full max-w-7xl">
          <div
            data-aos-once="true"
            data-aos="fade-up"
            data-aos-easing="ease"
            data-aos-duration="800"
            data-aos-delay="300"
            className="mb-10 flex flex-col items-center justify-center gap-2 px-4 lg:mb-16 lg:gap-4 lg:px-6"
          >
            <p className="text-sm font-bold text-yellow-450 lg:text-lg">수료생 결과물</p>
            <h4 className="text-center text-2xl font-bold leading-snug text-white lg:text-4xl lg:leading-[1.4]">
              사용자 경험을 개선한 <br className="hidden lg:block" />
              <span className="text-yellow-450">
                선배들의 <br className="block lg:hidden" />
                포트폴리오
              </span>
              를 확인해 보세요
            </h4>
          </div>
        </div>
        <div
          data-aos-once="true"
          data-aos="fade-up"
          data-aos-easing="ease"
          data-aos-duration="800"
          data-aos-delay="600"
          className={`${styles.section7_slider}`}
        >
          <ProjectOutputSliderItem contents={projectOutputList} />
        </div>
      </section>

      {/* Section8_특강1 */}
      <section className="min-h-[691px] bg-[#FFF9F5] pb-24 pt-20 lg:min-h-[1105px] lg:pb-[180px] lg:pt-[156px]">
        <div className="mx-auto w-full max-w-7xl px-4 lg:px-6">
          <div
            data-aos-once="true"
            data-aos="fade-up"
            data-aos-easing="ease"
            data-aos-duration="800"
            data-aos-delay="300"
            className="mb-10 flex flex-col items-center justify-center lg:mb-16"
          >
            <p className="mb-2 text-sm font-bold text-yellow-450 lg:mb-4 lg:text-lg">
              실무 클래스 1
            </p>
            <h4 className="mb-[18px] text-center text-2xl font-bold leading-snug text-label-normal lg:mb-7 lg:text-4xl lg:leading-[1.4]">
              여기서 끝이 아니에요!
              <br />
              UXUI 디자이너의 필수 역량인 <br className="block lg:hidden" />
              <span className="text-yellow-450">개발자와의 소통법</span>을 익혀요
            </h4>
            <p className="text-center text-sm leading-normal text-label-normal lg:text-lg">
              실제로 구현되려면 개발자와의 협업이 필수!
              <br />
              기업 프로세스를 이해하고, <br className="block lg:hidden" />
              원활한 커뮤니케이션 스킬을 익혀보세요.
            </p>
          </div>

          <div
            data-aos-once="true"
            data-aos="fade-up"
            data-aos-easing="ease"
            data-aos-duration="800"
            data-aos-delay="600"
            className={`${styles.section6_slider} ${styles.section8_slider}`}
          >
            <ClassOneSliderItem contents={classOneSlideList} />
          </div>
        </div>
      </section>

      {/* Section9_특강2 */}
      <section className="min-h-[905px] bg-[#FFF3EB] pb-24 pt-20 lg:min-h-[1221px] lg:pb-[180px] lg:pt-36">
        <div className="mx-auto w-full max-w-7xl px-4 lg:px-6">
          <div
            data-aos-once="true"
            data-aos="fade-up"
            data-aos-easing="ease"
            data-aos-duration="800"
            data-aos-delay="300"
            className="mb-10 flex flex-col items-center justify-center lg:mb-16"
          >
            <p className="mb-2 text-sm font-bold text-yellow-450 lg:mb-4 lg:text-lg">
              실무 클래스 2
            </p>
            <h4 className="mb-[18px] text-center text-2xl font-bold leading-snug text-label-normal lg:mb-7 lg:text-4xl lg:leading-[1.4]">
              <span className="text-yellow-450">APP + WEB</span>, <br className="block lg:hidden" />
              모든 환경에서 통하는
              <br />
              UXUI 디자인을 마스터하세요
            </h4>
            <p className="text-center text-sm leading-normal text-label-normal lg:text-lg">
              APP과 WEB에 따라 UXUI의 원칙이 달라집니다.
              <br />
              디자인의 차이를 이해하고, <br className="block lg:hidden" />
              크로스 플랫폼 환경에 강한 디자이너로 성장하세요.
            </p>
          </div>

          <div
            data-aos-once="true"
            data-aos="fade-up"
            data-aos-easing="ease"
            data-aos-duration="800"
            data-aos-delay="600"
            className={`${styles.section6_slider} ${styles.section9_slider}`}
          >
            <ClassTwoSliderItem contents={classTwoSlideList} />
          </div>
        </div>
      </section>

      {/* Section10_특강3 */}
      <section
        className={`${styles.section10_bg} min-h-[990px] bg-[#FCFAF9] pt-20 lg:min-h-[1471px] lg:pt-[156px]`}
      >
        <div className="mx-auto w-full max-w-7xl px-4 lg:px-6">
          <div
            data-aos-once="true"
            data-aos="fade-up"
            data-aos-easing="ease"
            data-aos-duration="800"
            data-aos-delay="300"
            className="mb-12 flex flex-col items-center justify-center lg:mb-16"
          >
            <p className="mb-2 text-sm font-bold text-yellow-450 lg:mb-4 lg:text-lg">
              실무 클래스 3
            </p>
            <h4 className="mb-3 text-center text-2xl font-bold leading-snug text-label-normal lg:mb-7 lg:text-4xl lg:leading-[1.4]">
              이론과 실무는 다릅니다.
              <br />
              실전에 강한 UXUI 디자인과 <br className="block lg:hidden" />
              커리어 전략을 배우세요
            </h4>
            <p className="text-center text-sm leading-normal text-label-normal lg:text-lg">
              UXUI 디자이너의 핵심 역량, 그리고 커리어 방향성까지!
              <br />
              단순히 ‘디자인을 잘하는 디자이너’를 넘어, ‘실무에서 <br className="block lg:hidden" />
              인정받는 디자이너’가 되는 법을 알려드려요.
            </p>
          </div>

          <div
            data-aos-once="true"
            data-aos="fade-up"
            data-aos-easing="ease"
            data-aos-duration="800"
            data-aos-delay="600"
            className={`${styles.curriculum_accordion_wrap} ${styles.curriculum_accordion_wrap_section10} hidden flex-row overflow-hidden border border-black bg-white lg:flex`}
          >
            <CurriculumTab curriculumDetailList={classThreeDetailList} />
          </div>
        </div>

        <ul
          data-aos-once="true"
          data-aos="fade-up"
          data-aos-easing="ease"
          data-aos-duration="800"
          data-aos-delay="600"
          className={`${styles.curriculum_accordion_wrap} ${styles.curriculum_accordion_wrap_section10} flex flex-col overflow-hidden lg:hidden`}
        >
          {classThreeDetailList.map((classThree, idx) => (
            <CurriculumAccordion contents={classThree} key={classThree.titleM} idx={idx} />
          ))}
        </ul>

        <p
          data-aos-once="true"
          data-aos="fade-up"
          data-aos-easing="ease"
          data-aos-duration="800"
          data-aos-delay="600"
          className="mt-[88px] text-center text-xl font-bold leading-tight text-label-normal lg:mt-[160px] lg:text-[32px] lg:leading-snug"
        >
          “디자인 배운 적 없는데,
          <br />
          따라갈 수 있을까요…?”
        </p>

        <div
          className={`${styles.section3_icon_arrow} absolute left-1/2 w-[71.47px] -translate-x-1/2 lg:w-[120px]`}
        >
          <img
            className="w-full object-contain"
            src="https://d35ai18pny966l.cloudfront.net/course/kdt/kdt-design-5th/section3_icon_arrow.png"
            alt="-"
          />
        </div>
      </section>

      {/* Section11_비전공자 안내 */}
      <section className="min-h-[849px] bg-[#EEEEEE] pb-20 pt-4 lg:min-h-[1077px] lg:pb-[180px] lg:pt-10">
        <div className="mx-auto w-full max-w-7xl px-4 lg:px-6">
          <div
            data-aos-once="true"
            data-aos="fade-up"
            data-aos-easing="ease"
            data-aos-duration="800"
            data-aos-delay="300"
            className="mb-12 flex flex-col items-center justify-center lg:mb-16"
          >
            <h4 className="text-center text-2xl font-bold leading-snug text-label-normal lg:text-4xl lg:leading-[1.4]">
              걱정하지 마세요!
              <br />
              <span className="text-yellow-450">비전공자도 끝까지 완주</span>할 수 있도록,{' '}
              <br className="block lg:hidden" />
              탄탄하게 준비했어요
            </h4>
          </div>

          <ul className="hidden flex-row gap-6 lg:flex">
            {classSupportList.map(classSupport => (
              <li
                className="flex flex-1 flex-col border border-black bg-white"
                key={classSupport.title}
              >
                <div className="w-full">
                  <Image
                    src={classSupport.imgUrlPc}
                    layout="fill"
                    objectFit="cover"
                    className="!relative w-full"
                    alt="-"
                  />
                </div>
                <div className="flex flex-col border-t border-black bg-white px-6 py-6">
                  <p className="max-w-fit bg-[rgba(255,119,16,0.10)] px-2.5 py-[5px] text-base font-bold text-yellow-450">
                    {classSupport.type}
                  </p>
                  <h6 className="my-4 whitespace-pre-line text-[22px] font-bold leading-normal text-label-normal">
                    {classSupport.title}
                  </h6>
                  <p className="whitespace-pre-line text-xl font-medium text-label-normal">
                    {classSupport.desc}
                  </p>
                  <div className="mt-8">
                    {classSupport.descList?.map(item => (
                      <p
                        key={`${classSupport.title}-${item}`}
                        className={`${styles.text_dot} ${styles.text_dot_section11} whitespace-pre-line text-base leading-normal text-label-neutral`}
                      >
                        {item}
                      </p>
                    ))}
                  </div>
                </div>
              </li>
            ))}
          </ul>
        </div>

        <div
          data-aos-once="true"
          data-aos="fade-up"
          data-aos-easing="ease"
          data-aos-duration="800"
          data-aos-delay="600"
          className={`${styles.section11_slider} lg:hidden`}
        >
          <ClassSupportSliderItem contents={classSupportList} />
        </div>
      </section>

      {/* Section12_강사진 */}
      <section
        id="teacher"
        className={`${styles.section12_bg} min-h-[2016px] bg-[#FCFAF9] pb-24 pt-20 lg:min-h-[1488px] lg:pb-[180px] lg:pt-36`}
      >
        <div className="mx-auto w-full max-w-7xl px-4 lg:px-6">
          <div
            data-aos-once="true"
            data-aos="fade-up"
            data-aos-easing="ease"
            data-aos-duration="800"
            data-aos-delay="300"
            className="mb-10 flex flex-col items-center justify-center gap-2 lg:mb-20 lg:gap-4"
          >
            <p className="text-sm font-bold text-yellow-450 lg:text-lg">강사진</p>
            <h4 className="text-center text-2xl font-bold leading-snug text-label-normal lg:text-4xl lg:leading-[1.4]">
              최고의 안내자와 함께,
              <br />
              최적의 UXUI 디자이너로 성장하세요
            </h4>
            <div className="my-[18px] w-full max-w-[164.2px] lg:mx-auto lg:my-7 lg:max-w-[338px]">
              <Image
                src={`https://d35ai18pny966l.cloudfront.net/course/kdt/kdt-design-5th/section12_intro_${
                  isMobile ? 'm' : 'pc'
                }.png`}
                layout="fill"
                objectFit="cover"
                className="!relative"
                alt="-"
              />
            </div>
            <p className="text-center text-sm leading-normal text-label-normal lg:text-lg">
              기업이 원하는 UXUI 디자이너는 단순한 스킬을 넘어,
              <br />
              실전에서 문제를 해결하는 능력을 갖춰야 합니다.
              <br />
              최전선에서 활약하는 강사진이 기초부터 실무 노하우까지{' '}
              <br className="block lg:hidden" />
              아낌없이 전수합니다.
            </p>
          </div>

          <div
            data-aos-once="true"
            data-aos="fade-up"
            data-aos-easing="ease"
            data-aos-duration="800"
            data-aos-delay="600"
            className="flex w-full flex-col items-center gap-3 overflow-hidden lg:flex-row lg:items-stretch lg:gap-4"
          >
            <div className="flex w-full flex-col border border-black bg-white p-4 lg:w-auto lg:flex-1 lg:p-6">
              <div className="mb-2 flex w-full flex-row items-center gap-4 lg:mb-4 lg:gap-6 lg:border-b lg:pb-6">
                <div className="inline-block h-[72px] w-[70px] shrink-0 lg:h-[120px] lg:w-[120px]">
                  <Image
                    src="https://d35ai18pny966l.cloudfront.net/course/kdt/kdt-design-5th/section12_teacher_img1.png"
                    layout="fill"
                    objectFit="contain"
                    className="!relative w-full"
                    alt="-"
                  />
                </div>
                <div className="flex w-full flex-1 flex-col lg:gap-0.5">
                  <p className="text-xs font-bold text-yellow-450 lg:text-sm">
                    디자인 기초 & UI 파트
                  </p>
                  <p className="text-base font-bold text-label-normal lg:text-xl">김대연 강사님</p>
                </div>
              </div>

              <div className="flex flex-col gap-4">
                <ul className="flex flex-col lg:gap-0.5">
                  <li
                    className={`${styles.text_dot} ${styles.text_dot_section12_darker} border-b border-[#404040] py-2 text-sm font-bold leading-normal text-label-normal lg:border-0 lg:py-0 lg:text-base`}
                  >
                    현) 아일롯 대표 컨설턴트
                  </li>
                  <li
                    className={`${styles.text_dot} ${styles.text_dot_section12_darker} border-b border-[#404040] py-2 text-sm font-bold leading-normal text-label-normal lg:border-0 lg:py-0 lg:text-base`}
                  >
                    현) LIZKO, Offshoring Dev Director
                  </li>
                  <li
                    className={`${styles.text_dot} ${styles.text_dot_section12} border-b border-[#404040] py-2 text-sm leading-normal text-label-neutral lg:border-0 lg:py-0 lg:text-base`}
                  >
                    전) W사, DBMS Solution CDO
                  </li>
                  <li
                    className={`${styles.text_dot} ${styles.text_dot_section12} border-b border-[#404040] py-2 text-sm leading-normal text-label-neutral lg:border-0 lg:py-0 lg:text-base`}
                  >
                    전) 한국기술교육대학교 LMS 컨텐츠 개발(Notion) 자문위원
                  </li>
                  <li
                    className={`${styles.text_dot} ${styles.text_dot_section12} pt-2 text-sm leading-normal text-label-neutral lg:pt-0 lg:text-base`}
                  >
                    전) 아주대학교 다학제 캡스톤 자문위원
                  </li>
                </ul>
                <div className="flex flex-col gap-1 bg-alternative p-4 lg:min-h-[156px]">
                  <p className="text-base font-bold text-label-normal">강사님 한마디</p>
                  <p className="text-base leading-normal text-label-neutral">
                    UXUI 디자인은 단순히 시각 디자인을 넘어 모든 IT 업계에서, 여러분들의 실무에서
                    기획과 개발까지 폭 넓게 기업의 비전과 제품의 혁신적인 가치를 부여하는 중요한
                    설계도를 만드는 일입니다. 다가오는 디지털 전환의 시대에서 쉽게 접해보는 AI와
                    자동화 업무까지 UXUI 디자인으로 함께 경험해보세요.
                  </p>
                </div>
              </div>
            </div>

            <div className="flex w-full flex-col border border-black bg-white p-4 lg:w-auto lg:flex-1 lg:p-6">
              <div className="mb-2 flex w-full flex-row items-center gap-4 lg:mb-4 lg:gap-6 lg:border-b lg:pb-6">
                <div className="inline-block h-[72px] w-[70px] shrink-0 lg:h-[120px] lg:w-[120px]">
                  <Image
                    src="https://d35ai18pny966l.cloudfront.net/course/kdt/kdt-design-5th/section12_teacher_img2.png"
                    layout="fill"
                    objectFit="contain"
                    className="!relative w-full"
                    alt="-"
                  />
                </div>
                <div className="flex w-full flex-1 flex-col lg:gap-0.5">
                  <p className="text-xs font-bold text-yellow-450 lg:text-sm">UX 파트</p>
                  <p className="text-base font-bold text-label-normal lg:text-xl">박정주 강사님</p>
                </div>
              </div>

              <div className="flex flex-col gap-4">
                <ul className="flex flex-col lg:gap-0.5">
                  <li
                    className={`${styles.text_dot} ${styles.text_dot_section12_darker} border-b border-[#404040] py-2 text-sm font-bold leading-normal text-label-normal lg:border-0 lg:py-0 lg:text-base`}
                  >
                    현) 스타트업 넛지(Nudge) CPO | Co-founder
                  </li>
                  <li
                    className={`${styles.text_dot} ${styles.text_dot_section12} border-b border-[#404040] py-2 text-sm leading-normal text-label-neutral lg:border-0 lg:py-0 lg:text-base`}
                  >
                    전) 한경 KDT UX 강사 | UX 기획 및 설계 강의
                  </li>
                  <li
                    className={`${styles.text_dot} ${styles.text_dot_section12} pt-2 text-sm leading-normal text-label-neutral lg:pt-0 lg:text-base`}
                  >
                    전) (주) 맞추다 Product designer | 창립 멤버
                  </li>
                </ul>
                <div className="flex flex-col gap-1 bg-alternative p-4 lg:min-h-[156px]">
                  <p className="text-base font-bold text-label-normal">강사님 한마디</p>
                  <p className="text-base leading-normal text-label-neutral">
                    UX 디자인은 IT 전반에 대한 깊은 이해를 바탕으로 사용자·개발팀·데이터와의
                    끊임없는 소통을 통해 경험을 설계하는 작업이라고 생각합니다. 저는 이 수업에서
                    디자인이 단순 미학을 넘어서 문제 해결을 위한 설계임을 알려드리고 싶습니다.
                    사용자 중심의 UX로 새로운 가치를 만들어 보세요.
                  </p>
                </div>
              </div>
            </div>

            <div className="flex w-full flex-col border border-black bg-white p-4 lg:w-auto lg:flex-1 lg:p-6">
              <div className="mb-2 flex w-full flex-row items-center gap-4 lg:mb-4 lg:gap-6 lg:border-b lg:pb-6">
                <div className="inline-block h-[72px] w-[70px] shrink-0 lg:h-[120px] lg:w-[120px]">
                  <Image
                    src="https://d35ai18pny966l.cloudfront.net/course/kdt/kdt-design-5th/section12_teacher_img3.png"
                    layout="fill"
                    objectFit="contain"
                    className="!relative w-full"
                    alt="-"
                  />
                </div>
                <div className="flex w-full flex-1 flex-col lg:gap-0.5">
                  <p className="text-xs font-bold text-yellow-450 lg:text-sm">프로젝트 파트</p>
                  <p className="text-base font-bold text-label-normal lg:text-xl">Sarah 강사님</p>
                </div>
              </div>

              <div className="flex flex-col gap-4">
                <ul className="flex flex-col lg:gap-0.5">
                  <li
                    className={`${styles.text_dot} ${styles.text_dot_section12_darker} border-b border-[#404040] py-2 text-sm font-bold leading-normal text-label-normal lg:border-0 lg:py-0 lg:text-base`}
                  >
                    현) 스타트업 A사 프로덕트 디자인 리드
                  </li>
                  <li
                    className={`${styles.text_dot} ${styles.text_dot_section12} border-b border-[#404040] py-2 text-sm leading-normal text-label-neutral lg:border-0 lg:py-0 lg:text-base`}
                  >
                    전) T사 UXUI 교육 컨설팅 참여
                  </li>
                  <li
                    className={`${styles.text_dot} ${styles.text_dot_section12} border-b border-[#404040] py-2 text-sm leading-normal text-label-neutral lg:border-0 lg:py-0 lg:text-base`}
                  >
                    전) N사 서비스 디자인 팀 (LG ThinQ 스마트 홈 서비스 구축)
                  </li>
                  <li
                    className={`${styles.text_dot} ${styles.text_dot_section12} border-b border-[#404040] py-2 text-sm leading-normal text-label-neutral lg:border-0 lg:py-0 lg:text-base`}
                  >
                    전) 연세대학교 HCI 랩 UX 연구원
                  </li>
                  <li
                    className={`${styles.text_dot} ${styles.text_dot_section12} pt-2 text-sm leading-normal text-label-neutral lg:pt-0 lg:text-base`}
                  >
                    전) UXUI 관련 SCI 저널 논문 게재
                  </li>
                </ul>
                <div className="flex flex-col gap-1 bg-alternative p-4 lg:min-h-[156px]">
                  <p className="text-base font-bold text-label-normal">강사님 한마디</p>
                  <p className="text-base leading-normal text-label-neutral">
                    연구와 현업 경험을 바탕으로 수강생들이 사용자를 깊이 이해하고 최적의 UXUI를
                    도출할 수 있도록 돕겠습니다. 실무 중심의 프로젝트 코칭을 통해, 보다 데이터
                    기반으로 논리적이고 감각적인 사용자 경험을 설계하는 실무자로 성장할 수 있도록
                    함께 하겠습니다.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Section13_사전설명회 */}
      {isAfterEarlySessionDate ? (
        <section className="min-h-[553px] bg-white pb-[100px] pt-20 lg:min-h-[1217px] lg:pb-40 lg:pt-36">
          <div className="mx-auto w-full max-w-7xl px-4 lg:px-6">
            <div
              data-aos-once="true"
              data-aos="fade-up"
              data-aos-easing="ease"
              data-aos-duration="800"
              data-aos-delay="300"
              className="mb-10 flex flex-col items-center justify-center gap-2 lg:mb-16 lg:gap-4"
            >
              <p className="text-sm font-bold text-yellow-450 lg:text-lg">
                UXUI 디자인 고민 상담소
              </p>
              <h4 className="text-center text-2xl font-bold text-label-normal lg:text-4xl">
                UXUI 디자인 고민 상담소 다시보기
              </h4>
              <p className="text-center text-sm leading-normal text-label-normal lg:text-lg">
                현업 전문가와 실시간 라이브로 진행된
                <br />
                UXUI 디자인 고민 상담소 다시보기
              </p>
            </div>
            <div
              data-aos-once="true"
              data-aos="fade-up"
              data-aos-easing="ease"
              data-aos-duration="800"
              data-aos-delay="600"
              className="flex flex-col"
            >
              <div
                className="h-auto overflow-hidden"
                style={{
                  position: 'relative',
                  paddingTop: '56.25%',
                }}
              >
                <ReactPlayer
                  alt="멋쟁이사자처럼 사전설명회 LIVE"
                  url="https://youtube.com/live/ijBn8ctWd9c"
                  controls={true}
                  width="100%"
                  height="100%"
                  muted
                  style={{
                    position: 'absolute',
                    top: 0,
                    left: 0,
                    width: '100%',
                    height: '100%',
                  }}
                />
              </div>
            </div>
          </div>
        </section>
      ) : (
        <section className="min-h-[730px] bg-white py-20 lg:min-h-[708px] lg:pb-40 lg:pt-36">
          <div className="mx-auto w-full max-w-7xl px-4 lg:flex lg:flex-row-reverse lg:items-center lg:justify-between lg:gap-16 lg:px-6">
            <div
              data-aos-once="true"
              data-aos="fade-up"
              data-aos-easing="ease"
              data-aos-duration="800"
              data-aos-delay="600"
              className="lg:w-1/2 lg:min-w-[400px] lg:max-w-[459px]"
            >
              <div className="flex w-full flex-col items-center justify-center lg:items-start lg:gap-3">
                <p className="mb-2 text-sm font-bold text-yellow-450 lg:mb-0 lg:text-lg">
                  UXUI 디자인 고민 상담소
                </p>
                <h4 className="mb-2 text-center text-2xl font-bold leading-tight text-label-normal lg:mb-0 lg:text-left lg:text-4xl">
                  현직자와 함께하는
                  <br />
                  UXUI 디자인 고민 상담소
                </h4>
                <p className="text-center text-sm leading-normal text-label-normal lg:text-left lg:text-lg">
                  인턴십 UXUI 취업 트렌드에 대해 이야기 나누고
                  <br />
                  질의응답까지 할 수 있는 시간!
                </p>
                <div className="my-5 w-full overflow-hidden lg:hidden">
                  <img
                    src="https://d35ai18pny966l.cloudfront.net/course/kdt/kdt-design-5th/section13_img_m.gif"
                    className="h-full w-full object-contain"
                    alt="*참고용 사전설명회 진행 모습"
                  />
                </div>
                <p className="mb-5 text-center text-sm font-bold leading-normal text-label-normal lg:my-0 lg:text-left lg:text-lg">
                  실무 경험이 풍부한 현직자와 함께,
                  <br />
                  교육 과정부터 포트폴리오까지 <br className="block lg:hidden" />
                  모든 궁금증을 해결하세요!
                </p>
                <p className="text-center text-sm font-bold leading-normal text-yellow-450 lg:text-left lg:text-lg">
                  일정 : 2025년 03월 12일(수), 오후 7시
                  <br />
                  장소 : Youtube 라이브 스트리밍
                </p>
              </div>
              <div className="mt-5 lg:mt-3">
                <Link
                  href="https://likelion2.typeform.com/to/sc4LnLWP"
                  target="_blank"
                  className="flex w-full items-center justify-center gap-2 bg-yellow-450 py-3.5 text-sm font-bold text-white lg:max-w-[395px] lg:gap-2.5 lg:py-5 lg:text-lg"
                >
                  디자인 고민 상담소 신청하기
                  <img
                    className="h-4 w-4 lg:h-[22px] lg:w-[22px]"
                    src="https://d35ai18pny966l.cloudfront.net/course/kdt/kdt-design-5th/pre-orientation_icon.png"
                    alt="사전설명회"
                  />
                </Link>
              </div>
            </div>
            <div
              data-aos-once="true"
              data-aos="fade-up"
              data-aos-easing="ease"
              data-aos-duration="800"
              data-aos-delay="300"
              className="hidden h-[404px] overflow-hidden lg:inline-block"
            >
              <img
                src="https://d35ai18pny966l.cloudfront.net/course/kdt/kdt-design-5th/section13_img_pc.gif"
                className="h-full w-full object-contain"
                alt="*참고용 사전설명회 진행 모습"
              />
            </div>
          </div>
        </section>
      )}

      {/* Section14_취업지원 */}
      <section
        id="support"
        className="min-h-[1377px] bg-[#EEEEEE] py-20 lg:min-h-[1877px] lg:pb-40 lg:pt-36"
      >
        <div className="mx-auto w-full max-w-7xl px-4 lg:px-6">
          <div
            data-aos-once="true"
            data-aos="fade-up"
            data-aos-easing="ease"
            data-aos-duration="800"
            data-aos-delay="300"
            className="mb-10 flex flex-col items-center justify-center gap-2 lg:mb-16 lg:gap-4"
          >
            <p className="text-sm font-bold text-yellow-450 lg:text-lg">취업 지원</p>
            <h4 className="text-center text-2xl font-bold leading-snug text-label-normal lg:text-4xl lg:leading-[1.4]">
              수료 후에도 끝까지 책임지는
              <br />
              <span className="text-yellow-450">역대급 취업 지원</span>
            </h4>
            <p className="text-center text-sm leading-normal text-label-normal lg:text-lg">
              이력서, 포트폴리오, 면접까지!
              <br />
              취업에 필요한 모든 과정을 도와드려요
            </p>
          </div>

          <div className="flex flex-col gap-3 lg:gap-6">
            <div
              data-aos-once="true"
              data-aos="fade-up"
              data-aos-easing="ease"
              data-aos-duration="800"
              data-aos-delay="600"
              className="flex flex-col items-center border border-black bg-white lg:flex-row"
            >
              <div className="w-full lg:w-1/2 lg:border-r lg:border-black">
                <Image
                  src={`https://d35ai18pny966l.cloudfront.net/course/kdt/kdt-design-5th/section14_img1_ver2_${
                    isMobile ? 'm' : 'pc'
                  }.png`}
                  layout="fill"
                  objectFit="cover"
                  className="!relative w-full"
                  alt="-"
                />
              </div>
              <div className="flex w-full flex-col gap-2 p-4 lg:w-1/2 lg:gap-3 lg:px-12">
                <p className="max-w-fit bg-[rgba(255,119,16,0.1)] px-2 py-1 text-xs font-bold text-yellow-450 lg:px-3 lg:text-lg">
                  취업 지원 1
                </p>
                <h6 className="text-lg font-bold leading-normal text-label-normal lg:text-2xl lg:leading-tight">
                  3번의 인턴십 기회 제공
                </h6>
                <div className="flex flex-col">
                  <p
                    className={`${styles.text_dot} ${styles.text_dot_section14} text-xs font-medium leading-normal text-label-neutral lg:text-base lg:font-normal`}
                  >
                    디자인 스튜디오 ‘디엘스(The Else)’ 의 정규직 전환형 인턴십 기회
                  </p>
                  <p
                    className={`${styles.text_dot} ${styles.text_dot_section14} text-xs font-medium leading-normal text-label-neutral lg:text-base lg:font-normal`}
                  >
                    멋쟁이사자처럼 인턴십 기회
                  </p>
                  <p
                    className={`${styles.text_dot} ${styles.text_dot_section14} text-xs font-medium leading-normal text-label-neutral lg:text-base lg:font-normal`}
                  >
                    프론트엔드, 백엔드 등 다양한 개발자들과 함께하는 6주 인턴십 기회
                  </p>
                </div>
              </div>
            </div>
            <div
              data-aos-once="true"
              data-aos="fade-up"
              data-aos-easing="ease"
              data-aos-duration="800"
              data-aos-delay="600"
              className="flex flex-col items-center border border-black bg-white lg:flex-row"
            >
              <div className="w-full lg:w-1/2 lg:border-r lg:border-black">
                <Image
                  src={`https://d35ai18pny966l.cloudfront.net/course/kdt/kdt-design-5th/section14_img2_${
                    isMobile ? 'm' : 'pc'
                  }.png`}
                  layout="fill"
                  objectFit="cover"
                  className="!relative w-full"
                  alt="-"
                />
              </div>
              <div className="flex w-full flex-col gap-2 p-4 lg:w-1/2 lg:gap-3 lg:px-12">
                <p className="max-w-fit bg-[rgba(255,119,16,0.1)] px-2 py-1 text-xs font-bold text-yellow-450 lg:px-3 lg:text-lg">
                  취업 지원 2
                </p>
                <h6 className="text-lg font-bold leading-normal text-label-normal lg:text-2xl lg:leading-tight">
                  약 100시간의 포트폴리오 <br className="block lg:hidden" />
                  패키징 서포트(1:1 멘토링)
                </h6>
                <div className="flex flex-col">
                  <p
                    className={`${styles.text_dot} ${styles.text_dot_section14} text-xs font-medium leading-normal text-label-neutral lg:text-base lg:font-normal`}
                  >
                    업계에서 인정받는 포트폴리오 제작법 & 차별화 전략 학습
                  </p>
                  <p
                    className={`${styles.text_dot} ${styles.text_dot_section14} text-xs font-medium leading-normal text-label-neutral lg:text-base lg:font-normal`}
                  >
                    기업 채용 공고(JD) 분석을 통한 맞춤형 포트폴리오 작성
                  </p>
                  <p
                    className={`${styles.text_dot} ${styles.text_dot_section14} text-xs font-medium leading-normal text-label-neutral lg:text-base lg:font-normal`}
                  >
                    포트폴리오 완성 특강 + 현직 디자이너의 1:1 피드백 제공
                  </p>
                </div>
              </div>
            </div>
          </div>

          <h6
            data-aos-once="true"
            data-aos="fade-up"
            data-aos-easing="ease"
            data-aos-duration="800"
            data-aos-delay="600"
            className="my-12 text-center text-xl font-bold text-label-normal lg:my-20 lg:text-2xl"
          >
            3단계 취업 지원 프로그램
          </h6>

          <div
            data-aos-once="true"
            data-aos="fade-up"
            data-aos-easing="ease"
            data-aos-duration="800"
            data-aos-delay="600"
            className={`${styles.curriculum_accordion_wrap} ${styles.curriculum_accordion_wrap_section14} hidden flex-row overflow-hidden border border-black bg-white lg:flex`}
          >
            <CurriculumTab curriculumDetailList={careerSupportList} />
          </div>
        </div>

        <ul
          data-aos-once="true"
          data-aos="fade-up"
          data-aos-easing="ease"
          data-aos-duration="800"
          data-aos-delay="600"
          className={`${styles.curriculum_accordion_wrap} flex flex-col overflow-hidden lg:hidden`}
        >
          {careerSupportList.map((curriculum, idx) => (
            <CurriculumAccordion contents={curriculum} key={curriculum.titleM} idx={idx} />
          ))}
        </ul>
      </section>

      {/* Section15_추가혜택 */}
      <section className="min-h-[753px] bg-[#333333] py-20 lg:min-h-[998px] lg:py-40 lg:pt-36">
        <div className="mx-auto w-full max-w-[1700px] px-4 lg:px-6">
          <div
            data-aos-once="true"
            data-aos="fade-up"
            data-aos-easing="ease"
            data-aos-duration="800"
            data-aos-delay="300"
            className="mb-12 flex flex-col items-center justify-center gap-2 lg:mb-16 lg:gap-4"
          >
            <p className="text-sm font-bold text-yellow-450 lg:text-lg">추가 혜택</p>
            <h4 className="text-center text-2xl font-bold leading-snug text-white lg:text-4xl lg:leading-[1.4]">
              열정만 갖고 오세요!
              <br />
              취업까지 필요한 모든걸 지원합니다
            </h4>
          </div>

          <ul
            data-aos-once="true"
            data-aos="fade-up"
            data-aos-easing="ease"
            data-aos-duration="800"
            data-aos-delay="600"
            className="hidden flex-row gap-6 lg:flex"
          >
            {benefitSlideList.map(benefit => (
              <li className="flex flex-1 flex-col bg-gray-900" key={benefit.title}>
                <div className="w-full">
                  <Image
                    src={benefit.imgUrlPc}
                    layout="fill"
                    objectFit="cover"
                    className="!relative w-full"
                    alt="-"
                  />
                </div>
                <div className="flex flex-col gap-2 p-6">
                  <h6 className="whitespace-pre-line text-xl font-bold leading-normal text-white">
                    {benefit.title}
                  </h6>
                  <p className="whitespace-pre-line text-base leading-normal text-white">
                    {benefit.desc}
                  </p>
                  {benefit.option && <p className="text-sm text-label-neutral">{benefit.option}</p>}
                </div>
              </li>
            ))}
          </ul>
        </div>

        <div
          data-aos-once="true"
          data-aos="fade-up"
          data-aos-easing="ease"
          data-aos-duration="800"
          data-aos-delay="600"
          className={`${styles.benefit_slider} lg:hidden`}
        >
          <BenefitSliderItem contents={benefitSlideList} />
        </div>

        <p className="mt-[53px] text-center text-xs font-medium text-label-assistive lg:mt-16 lg:text-base">
          *만 19세 이상의 내일배움카드 소지자만 부트캠프 참여가 가능합니다.
        </p>
      </section>

      {/* Section16_수료생 후기 */}
      <section className="min-h-[784px] bg-trueGray-800 py-20 lg:min-h-[1568px] lg:py-40 lg:pt-36">
        <div className="mx-auto w-full max-w-7xl px-4 lg:px-6">
          <div
            data-aos-once="true"
            data-aos="fade-up"
            data-aos-easing="ease"
            data-aos-duration="800"
            data-aos-delay="300"
            className="mb-10 flex flex-col items-center justify-center gap-2 lg:mb-16 lg:gap-4"
          >
            <p className="text-sm font-bold text-yellow-450 lg:text-lg">수료생 후기</p>
            <h4 className="text-center text-2xl font-bold text-white lg:text-4xl">
              선배들의 생생한 이야기
            </h4>
          </div>

          <ul
            data-aos-once="true"
            data-aos="fade-up"
            data-aos-easing="ease"
            data-aos-duration="800"
            data-aos-delay="600"
            className="mx-auto hidden max-w-[814px] flex-col gap-6 lg:flex"
          >
            {reviewList.map(review => (
              <li
                className="flex w-full flex-row items-center gap-6 border border-[#00E0FF] bg-[#303030] px-6 py-5"
                key={review.title}
              >
                <div className="h-[84px] shrink-0 border-r border-[#404040] pr-6">
                  <div className="h-[84px] w-[84px]">
                    <Image
                      src={review.imgUrlPc}
                      layout="fill"
                      objectFit="cover"
                      className="!relative w-full"
                      alt="-"
                    />
                  </div>
                </div>
                <div className="flex flex-1 flex-col gap-3">
                  <h6 className="text-xl font-bold leading-normal text-white">{review.title}</h6>
                  <p className="whitespace-pre-line text-base leading-normal text-label-assistive">
                    {review.desc}
                  </p>
                </div>
              </li>
            ))}
          </ul>
        </div>

        <div
          data-aos-once="true"
          data-aos="fade-up"
          data-aos-easing="ease"
          data-aos-duration="800"
          data-aos-delay="600"
          className={`${styles.section16_slider} lg:hidden`}
        >
          <ReviewSliderItem contents={reviewList} />
        </div>
      </section>

      {/* section17_선발일정 */}
      <section
        id="condition"
        className="min-h-[1011px] bg-gray-900 py-20 lg:min-h-[851px] lg:pb-[140px] lg:pt-[120px]"
      >
        <div className="mx-auto flex w-full max-w-7xl flex-col px-4 lg:mx-auto lg:flex-row lg:flex-wrap lg:gap-6 lg:px-6">
          <div className="w-full lg:w-auto lg:flex-1">
            <div
              data-aos-once="true"
              data-aos="fade-up"
              data-aos-easing="ease"
              data-aos-duration="800"
              data-aos-delay="300"
              className="mb-6 lg:mb-8"
            >
              <h4 className="text-center text-2xl font-bold text-white lg:text-left lg:text-3xl">
                지원 및 선발 안내
              </h4>
            </div>

            <div
              data-aos-once="true"
              data-aos="fade-up"
              data-aos-easing="ease"
              data-aos-duration="800"
              data-aos-delay="600"
              className="flex flex-col"
            >
              <div className="relative flex w-full flex-col lg:hidden">
                <div className="absolute -left-[2.4px] -top-[2.4px] h-1.5 w-1.5 border border-[#00E0FF] bg-white"></div>
                <div className="absolute -right-[2.4px] -top-[2.4px] h-1.5 w-1.5 border border-[#00E0FF] bg-white"></div>
                <div className="absolute -bottom-[2.4px] -left-[2.4px] h-1.5 w-1.5 border border-[#00E0FF] bg-white"></div>
                <div className="absolute -bottom-[2.4px] -right-[2.4px] h-1.5 w-1.5 border border-[#00E0FF] bg-white"></div>
                {ApplySchedule1List.map(edu => (
                  <dl
                    className="flex flex-col gap-2 border border-[#00E0FF] bg-trueGray-800 px-5 py-4"
                    key={edu.title}
                  >
                    <dt className="w-full text-sm font-semibold leading-normal text-yellow-450">
                      {edu.title}
                    </dt>
                    <dd className="whitespace-pre-line text-sm leading-normal text-label-assistive">
                      {edu.content}
                    </dd>
                  </dl>
                ))}
              </div>

              <div className="relative mt-3 flex w-full flex-col lg:hidden">
                <div className="absolute -left-[2.4px] -top-[2.4px] h-1.5 w-1.5 border border-[#00E0FF] bg-white"></div>
                <div className="absolute -right-[2.4px] -top-[2.4px] h-1.5 w-1.5 border border-[#00E0FF] bg-white"></div>
                <div className="absolute -bottom-[2.4px] -left-[2.4px] h-1.5 w-1.5 border border-[#00E0FF] bg-white"></div>
                <div className="absolute -bottom-[2.4px] -right-[2.4px] h-1.5 w-1.5 border border-[#00E0FF] bg-white"></div>
                {ApplySchedule2List.map(edu => (
                  <dl
                    className="flex flex-col gap-2 border border-[#00E0FF] bg-trueGray-800 px-5 py-4"
                    key={edu.title}
                  >
                    <dt className="w-full text-sm font-semibold leading-normal text-yellow-450">
                      {edu.title}
                    </dt>
                    <dd className="whitespace-pre-line text-sm leading-normal text-label-assistive">
                      {edu.content}
                    </dd>
                  </dl>
                ))}
              </div>

              <div className="relative hidden w-full flex-col lg:flex">
                <div className="absolute -left-[7px] -top-[7px] h-3.5 w-3.5 border border-[#00E0FF] bg-white lg:border-[2px]"></div>
                <div className="absolute -right-[7px] -top-[7px] h-3.5 w-3.5 border border-[#00E0FF] bg-white lg:border-[2px]"></div>
                <div className="absolute -bottom-[7px] -left-[7px] h-3.5 w-3.5 border border-[#00E0FF] bg-white lg:border-[2px]"></div>
                <div className="absolute -bottom-[7px] -right-[7px] h-3.5 w-3.5 border border-[#00E0FF] bg-white lg:border-[2px]"></div>

                <div className="min-h-[215px] border border-[#00E0FF] bg-trueGray-800 px-6 py-5 lg:border-[2px]">
                  {ApplySchedule1List.map(edu => (
                    <dl
                      className="mb-3 flex flex-row items-center gap-5 border-b border-[#3D3D3D] pb-3"
                      key={edu.title}
                    >
                      <dt className="w-[95px] text-base font-bold leading-normal text-yellow-450">
                        {edu.title}
                      </dt>
                      <dd className="flex-1 whitespace-pre-line text-left text-base leading-normal text-label-assistive">
                        {edu.content}
                      </dd>
                    </dl>
                  ))}
                  {ApplySchedule2List.map(edu => (
                    <dl className="flex flex-row items-start gap-5" key={edu.title}>
                      <dt className="w-[95px] whitespace-pre-line text-base font-bold leading-normal text-yellow-450">
                        {edu.title}
                      </dt>
                      <dd className="flex-1 whitespace-pre-line text-left text-base leading-normal text-label-assistive">
                        {edu.content}
                      </dd>
                    </dl>
                  ))}
                </div>
              </div>
            </div>
          </div>

          <div className="mt-20 w-full lg:mt-0 lg:w-auto lg:flex-1">
            <div
              data-aos-once="true"
              data-aos="fade-up"
              data-aos-easing="ease"
              data-aos-duration="800"
              data-aos-delay="300"
              className="mb-6 lg:mb-8"
            >
              <h4 className="text-center text-2xl font-bold text-white lg:text-left lg:text-3xl">
                교육 일정 안내
              </h4>
            </div>

            <div
              data-aos-once="true"
              data-aos="fade-up"
              data-aos-easing="ease"
              data-aos-duration="800"
              data-aos-delay="600"
              className="flex flex-col"
            >
              <div className="relative w-full flex-col lg:flex">
                <div className="absolute -left-[2.4px] -top-[2.4px] h-1.5 w-1.5 border border-[#00E0FF] bg-white lg:-left-[7px] lg:-top-[7px] lg:h-3.5 lg:w-3.5 lg:border-[2px]"></div>
                <div className="absolute -right-[2.4px] -top-[2.4px] h-1.5 w-1.5 border border-[#00E0FF] bg-white lg:-right-[7px] lg:-top-[7px] lg:h-3.5 lg:w-3.5 lg:border-[2px]"></div>
                <div className="absolute -bottom-[2.4px] -left-[2.4px] h-1.5 w-1.5 border border-[#00E0FF] bg-white lg:-bottom-[7px] lg:-left-[7px] lg:h-3.5 lg:w-3.5 lg:border-[2px]"></div>
                <div className="absolute -bottom-[2.4px] -right-[2.4px] h-1.5 w-1.5 border border-[#00E0FF] bg-white lg:-bottom-[7px] lg:-right-[7px] lg:h-3.5 lg:w-3.5 lg:border-[2px]"></div>

                <div className="border border-[#00E0FF] bg-trueGray-800 px-5 py-4 lg:border-[2px] lg:px-6 lg:py-5">
                  {EduScheduleList.map(edu => (
                    <li
                      className="flex flex-row items-center justify-center gap-5 border-b border-[#3D3D3D] py-2 first-of-type:pt-0 last-of-type:border-0 last-of-type:pb-0 lg:gap-8 lg:py-3"
                      key={edu.title}
                    >
                      <h6 className="w-[53px] shrink-0 text-sm font-semibold leading-normal text-yellow-450 lg:w-[60px] lg:text-base lg:font-bold">
                        {edu.title}
                      </h6>
                      <p className="flex-1 whitespace-pre-line text-sm text-label-assistive lg:whitespace-normal lg:text-base">
                        {edu.content}
                      </p>
                    </li>
                  ))}
                </div>
              </div>
            </div>
          </div>

          <div
            data-aos-once="true"
            data-aos="fade-up"
            data-aos-easing="ease"
            data-aos-duration="800"
            data-aos-delay="600"
            className="relative mt-5 w-full"
          >
            <div className="absolute -left-[2.4px] -top-[2.4px] h-1.5 w-1.5 border border-[#00E0FF] bg-white lg:-left-[7px] lg:-top-[7px] lg:h-3.5 lg:w-3.5 lg:border-[2px]"></div>
            <div className="absolute -right-[2.4px] -top-[2.4px] h-1.5 w-1.5 border border-[#00E0FF] bg-white lg:-right-[7px] lg:-top-[7px] lg:h-3.5 lg:w-3.5 lg:border-[2px]"></div>
            <div className="absolute -bottom-[2.4px] -left-[2.4px] h-1.5 w-1.5 border border-[#00E0FF] bg-white lg:-bottom-[7px] lg:-left-[7px] lg:h-3.5 lg:w-3.5 lg:border-[2px]"></div>
            <div className="absolute -bottom-[2.4px] -right-[2.4px] h-1.5 w-1.5 border border-[#00E0FF] bg-white lg:-bottom-[7px] lg:-right-[7px] lg:h-3.5 lg:w-3.5 lg:border-[2px]"></div>
            <div className="flex w-full flex-col border border-[#00E0FF] bg-trueGray-800 px-5 py-4 lg:border-[2px] lg:px-6 lg:py-5">
              <h5 className="flex-1 text-sm font-bold text-yellow-450 lg:text-base">
                멋쟁이사자처럼 UXUI 부트캠프 지원조건
              </h5>

              <ul className="mt-2 flex w-full flex-col lg:mt-3">
                <li
                  className={`${styles.text_dot} ${styles.text_dot_section17} border-t border-[#3D3D3D] py-2 text-sm leading-normal text-label-assistive lg:py-3 lg:text-base`}
                >
                  국민내일배움카드 보유자 혹은 발급 가능하신 분
                </li>
                <li
                  className={`${styles.text_dot} ${styles.text_dot_section17} border-t border-[#3D3D3D] py-2 text-sm leading-normal text-label-assistive lg:py-3 lg:text-base`}
                >
                  평일 오전 9시 ~ 오후 6시 수업 참여 가능하신 분
                </li>
                <li
                  className={`${styles.text_dot} ${styles.text_dot_section17} border-t border-[#3D3D3D] py-2 text-sm leading-normal text-label-assistive lg:py-3 lg:text-base`}
                >
                  직장 혹은 학교 등과 병행하지 않고 수업에만 집중 <br className="block lg:hidden" />
                  가능하신 분
                </li>
                <li
                  className={`${styles.text_dot} ${styles.text_dot_section17} border-t border-[#3D3D3D] pt-2 text-sm leading-normal text-label-assistive lg:pt-3 lg:text-base`}
                >
                  국내에 거주하고 계신 분
                </li>
              </ul>
            </div>
          </div>
        </div>
      </section>

      {/* section18_자주묻는질문 */}
      <section className="bg-white pb-[120px] pt-20 lg:py-[120px]">
        <div
          data-aos-once="true"
          data-aos="fade-up"
          data-aos-easing="ease"
          data-aos-duration="800"
          data-aos-delay="300"
          className="mx-auto w-full max-w-7xl px-4 lg:px-6"
        >
          <h4 className="mb-6 text-center text-xl font-bold text-label-normal lg:text-4xl">
            자주 묻는 질문
          </h4>
          <ul
            data-aos-once="true"
            data-aos="fade-up"
            data-aos-easing="ease"
            data-aos-duration="800"
            data-aos-delay="300"
            className="mx-auto mb-10 flex max-w-[324px] flex-wrap items-center justify-center gap-1.5 lg:mb-16 lg:max-w-none lg:flex-nowrap lg:gap-2"
          >
            {bootCampFaqTabList.map(tabItem => {
              const isActive = tabItem.value === faqTab
              return (
                <li
                  className={`${
                    isActive
                      ? 'bg-yellow-450 text-white'
                      : 'border border-normal bg-white text-gray-400'
                  } cursor-pointer rounded-full px-5 py-1.5 text-xs font-bold lg:px-6 lg:py-2 lg:text-sm`}
                  onClick={() => onClickFaqTab(tabItem.value)}
                  key={tabItem.value}
                >
                  {tabItem.label}
                </li>
              )
            })}
          </ul>
          <ul
            data-aos-once="true"
            data-aos="fade-up"
            data-aos-easing="ease"
            data-aos-duration="800"
            data-aos-delay="600"
            className="mx-auto flex flex-col"
          >
            {faqList.map(faq => (
              <li
                className={`${styles.faqItem} border-b border-[#E5E5E5] py-4 first-of-type:pt-0 last-of-type:border-0 last-of-type:pb-0 lg:py-6`}
                key={faq.question}
              >
                <details className="group overflow-hidden">
                  <summary className="cursor-pointer list-none group-open:pb-1 lg:group-open:pb-2">
                    <div className="flex w-full items-center justify-between gap-4">
                      <div>
                        <p
                          className={`${styles.faq_item_title} text-sm font-semibold text-label-normal lg:text-lg`}
                        >
                          {faq.question}
                        </p>
                      </div>
                      <ChevronDownIcon className="w-4 shrink-0 text-gray-500 group-open:rotate-180 lg:w-6" />
                    </div>
                  </summary>
                  <div className="pl-5 lg:pl-[22px]">
                    <div className="whitespace-pre-wrap text-sm leading-normal text-gray-500 lg:text-base">
                      {faq.answer && (
                        <span className="max-w-full">
                          {faq.answer}
                          {faq.externalUrl1 && (
                            <>
                              {' '}
                              자세한 발급 과정은 아래 링크를 통해 확인 가능합니다.
                              <br />-{' '}
                              <Link href={faq.externalUrl1} target="_blank" className="underline">
                                {' '}
                                {faq.urlName1}
                              </Link>
                              {faq.secondAnswer}
                            </>
                          )}
                          {faq.externalUrl2 && (
                            <>
                              <br />-{' '}
                              <Link href={faq.externalUrl2} target="_blank" className="underline">
                                {' '}
                                {faq.urlName2}
                              </Link>
                            </>
                          )}
                        </span>
                      )}
                      {faq.answerList &&
                        faq.answerList.map(el => (
                          <p key={el} className="text-sm text-gray-500 lg:text-base">
                            {el}
                          </p>
                        ))}
                    </div>
                  </div>
                </details>
              </li>
            ))}
          </ul>
          <div className="mt-10 flex flex-col items-center justify-between gap-3 rounded-md bg-[#FFF3EB] p-3 lg:mt-16 lg:flex-row lg:items-center lg:rounded-lg lg:p-10">
            <p className="flex-1 text-center text-sm font-semibold text-label-normal lg:text-left lg:text-lg lg:font-bold">
              더 궁금한 점이 있다면 <br className="block lg:hidden" />
              언제든지 교육 매니저에게 물어보세요!
            </p>
            <div className="flex w-full flex-row gap-1.5 lg:w-auto lg:gap-2.5">
              <Link
                href="https://likelion.channel.io/workflows/728540"
                target="_blank"
                className="flex h-9 flex-1 flex-row items-center justify-center gap-1.5 rounded bg-white px-3 text-sm font-bold text-yellow-450 lg:h-[50px] lg:w-[206px] lg:gap-2 lg:rounded-lg lg:text-lg"
              >
                1:1 문의하기
                <img
                  src="https://d35ai18pny966l.cloudfront.net/course/kdt/kdt-frontend-13th/faq_icon_btn.png"
                  className="h-4 w-4 shrink-0 object-contain lg:h-[18px] lg:w-[18px]"
                  alt="1:1 문의하기"
                />
              </Link>
              <div
                className="flex h-9 w-9 shrink-0 items-center justify-center rounded bg-yellow-450 lg:h-[50px] lg:w-[50px] lg:rounded-lg"
                onClick={() => copyUrlShare('https://bootcamp.likelion.net/school/kdt-design-5th')}
              >
                <img
                  src="https://d35ai18pny966l.cloudfront.net/course/kdt/kdt-frontend-13th/faq_icon_share.png"
                  className="h-4 w-4 shrink-0 object-contain lg:h-6 lg:w-6"
                />
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  )
}

export default DesignSchool5th
